import React from 'react';
import { Checkbox, FormControlLabel, FormControl } from '@mui/material';
import { styled } from '@mui/system';

const colors = {
  primary: {
    main: '#995A00',
    nuetral: '#8C8C8C',
    hover: '#666666',
    disabled: '#D9D9D9',
    text: '#666666',
  },
  error: {
    main: '#CC0000',

  }
};

const StyledCheckbox = styled(Checkbox)(({ theme, color = 'primary', size = 'medium' }) => {
  const colorScheme = colors[color] || colors.primary;
  
  const sizeStyles = {
    small: {
      '& .MuiSvgIcon-root': { fontSize: 18 },
      '&.MuiCheckbox-root': { padding: '6px 6px 6px 6px' }
    },
    medium: {
      '& .MuiSvgIcon-root': { fontSize: 20 },
      '&.MuiCheckbox-root': { padding: '8px 8px 8px 8px' }
    },
    large: {
      '& .MuiSvgIcon-root': { fontSize: 24 },
      '&.MuiCheckbox-root': { padding: '10px 10px 10px 10px' }
    }
  };

  return {
    color: colors.primary.nuetral,
    // padding: 8,
    alignItems: 'start',
    '&:hover': {
        color:  colors.primary.hover,
        backgroundColor: '#00000000',
    },
    '&.Mui-checked': {
        color: colors.primary.main,
    },
    '&.MuiCheckbox-indeterminate': {
      color: colorScheme.main,
    },
    '&.Mui-disabled': {
        cursor: 'not-allowed',
        '&.Mui-checked': {
            color: colorScheme.disabled,
        },
    },
    '&.Mui-error': {
      color: colors.error.main,
      '&.Mui-checked': {
        color: colors.error.main,
      },
    },

    transition: theme.transitions.create(['color', 'background-color'], {
      duration: theme.transitions.duration.shorter,
    }),
    ...sizeStyles[size],
  };
});

const StyledFormControlLabel = styled(FormControlLabel)(({ theme, labelPlacement = 'end' }) => ({
    margin: 0,
    alignItems:'center',
    display: 'flex',
    '& .MuiFormControlLabel-label': {
        fontSize: '13px',
        lineHeight: '20px',
        color: '#333333',
        fontWeight: 600,
        userSelect: 'none',
    },
    '&.Mui-disabled': {
        '& .MuiFormControlLabel-label' : {
            color: colors.primary.nuetral,
        },
    },
    '&.Mui-error': {
      color: colors.error.main,
      '& .MuiFormControlLabel-label' : {
        color: colors.error.main,
      },
      '&.Mui-checked': {
        color: colors.error.main,
      },
    },
}));

const CustomCheckbox = React.forwardRef(({
  label,
  checked,
  defaultChecked,
  indeterminate = false,
  disabled = false,
  required = false,
  error = false,
  color = 'primary',
  size = 'medium',
  labelPlacement = 'end',
  onChange,
  name,
  value,
  id,
  className,
  sx,
  alignment = 'center',
  ...props
}, ref) => {
  const checkboxId = id || `checkbox-${Math.random().toString(36).substr(2, 9)}`;
  
  const checkboxElement = (
    <StyledCheckbox
      ref={ref}
      id={checkboxId}
      checked={checked}
      defaultChecked={defaultChecked}
      indeterminate={indeterminate}
      disabled={disabled}
      required={required}
      color={color}
      size={size}
      onChange={onChange}
      name={name}
      value={value}
      className={`${className || ''} ${error ? 'Mui-error' : ''}`}
      sx={sx}
      {...props}
    />
  );

  if (!label) {
    return checkboxElement;
  }

  return (
    <FormControl error={error} disabled={disabled}>
      <StyledFormControlLabel
        control={checkboxElement}
        label={label}
        labelPlacement={labelPlacement}
        disabled={disabled}
        sx={{ alignItems: alignment }}
      />
    </FormControl>
  );
});

CustomCheckbox.displayName = 'CustomCheckbox';

export default CustomCheckbox;